import {
  Box,
  Button,
  FileInput,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { WarranteeSamsung } from "../../../model/TblWarranteeSamsung";
import { useState } from "react";
import { createWarranteeSamsung } from "../../../api/ApiWarranteeSamsung";

const CreateView = ({ sessionId, onSearch }: createViewProps) => {
  const [file, setFile] = useState<File | null>(null);
  const [startRow, setStartRow] = useState<string>("");

  const handleCreateWarranteeSamsung = async () => {
    open();
    const data = {
      formFile: file,
      sessionId: sessionId,
      startRow: startRow,
    };

    await createWarranteeSamsung(data);
    onSearch();
    close();
    modals.closeAll();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  return (
    <>
      <Box className="flex-none" miw={950} maw={950} mx="auto">
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <FileInput
            label={"Chọn file"}
            placeholder={"Nhập file"}
            withAsterisk
            mt="md"
            accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            value={file}
            onChange={setFile}
          />
          <TextInput
            label={"Bắt đầu từ dòng"}
            placeholder={"Nhập dòng bắt đầu đọc dữ liệu"}
            mt="md"
            type="number"
            value={startRow}
            onChange={(e) => setStartRow(e.currentTarget.value)}
          />
        </Group>

        <Group justify="flex-end" mt="lg">
          <Button
            color="#3598dc"
            loading={visible}
            onClick={handleCreateWarranteeSamsung}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <Button
            variant="outline"
            color="black"
            type="button"
            loading={visible}
            onClick={() => modals.closeAll()}
            leftSection={<IconX size={18} />}
          >
            Đóng
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default CreateView;

type createViewProps = {
  sessionId: number | null;
  onSearch: Function;
};
